export const baseUrl = () => {
  if (window.location.host === "localhost:3000") {
    return "https://drjay.apollopharmacyrx.com/";
    // return "https://apollopharmacyrx.com/";
  } else {
    return "/"; // http://stackoverflow.com
  }
};